export const optionInputs = [
    { label: 'Yes', value: 'yes' },
    { label: 'No', value: 'no' },
];

export const educationInputs = [
    { label: 'Primary', value: 'Primary' },
    { label: 'High School', value: 'High School' },
    { label: 'Diploma Level', value: 'Diploma Level' },
    { label: 'Bachelors degree', value: 'Bachelors degree' },
    { label: 'Postgraduate Degree', value: 'Postgraduate Degree' },
    { label: 'None', value: 'None' },
];

export const genderInputs = [
    { label: 'Male', value: 'male' },
    { label: 'Female', value: 'female' },
];

export const salvationInputs = [
    { label: 'Saved', value: 'saved' },
    { label: 'Not Saved', value: 'un_saved' },
];

export const gender2Inputs = [
    { label: 'Male', value: 'male' },
    { label: 'Female', value: 'female' },
    { label: 'Prefer not to say', value: 'not_say' },
];

export const maritalInputs = [
    { label: 'Single', value: 'single' },
    { label: 'Married', value: 'married' },
    { label: 'Divorced', value: 'divorced' },
    { label: 'Widowed', value: 'widowed' },
];

export const videoTypeInputs = [
    { value: 'YouTube', label: 'YouTube' },
    { value: 'Facebook', label: 'Facebook' },
];

export const devotionTypeInputs = [
    { value: 'sermon', label: 'Sermon' },
    { value: 'prayer', label: 'Prayer' },
    { value: 'story', label: 'Story' },
];
